<template>
  <div class="login">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>E-Заказ</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-layout justify-center align-center>
                  <span class="font-weight-light headline text-uppercase"
                    >Interfarmax</span
                  >
                </v-layout>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  :prepend-icon="icons.account"
                  name="login"
                  label="Пользователь"
                  type="text"
                  v-model="loginModel.user"
                ></v-text-field>
                <v-text-field
                  :prepend-icon="icons.lock"
                  name="password"
                  label="Пароль"
                  v-model="loginModel.password"
                  :append-icon="showPassword ? icons.eye : icons.eyeOff"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  v-on:keyup.enter="signin(loginModel)"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="signin(loginModel)">Войти</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { Icon } from "@/helpers";

export default {
  computed: {},
  methods: {
    ...mapActions({
      login: "users/LOGIN",
    }),
    signin: async function (model) {
      await this.login(model);
      this.$router.push("/");
    },
  },
  data: () => ({
    loginModel: {
      user: "",
      password: "",
    },
    showPassword: false,
    icons: {
      account: Icon.account,
      eye: Icon.eye,
      eyeOff: Icon.eyeOff,
      lock: Icon.lock,
    },
  }),
};
</script>
